<template>
    <div class="reference-house-selector">
        <!-- Carousel -->
        <swiper class="" ref="refHouseSwiper">
            <swiper-slide v-for="refHouse in filteredReferenceHouses" :key="refHouse.id">
                <reference-house :refHouse="refHouse" :apartmentSizeDict="apartmentSizes"></reference-house>
            </swiper-slide>
        </swiper>

        <!-- Controls -->
        <a class="left carousel-control" v-on:click.stop="slidePrev()">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control" v-on:click.stop="slideNext()">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>

        <!-- Indicators -->
        <ol class="carousel-indicators">
            <li v-for="(refHouse, index) in filteredReferenceHouses" :key="refHouse.id" :class="{active: isCurrent(index)}" v-on:click="slideTo(index)">{{index + 1}}</li>
        </ol>
    </div>
</template>

<script>
    import ReferenceHouse from "./refHouse"
    import { mapGetters } from "vuex"
    import _ from "lodash"

    export default {
        methods: {
            slidePrev() {
                return this.swiper.slidePrev()
            },
            slideNext() {
                return this.swiper.slideNext()
            },
            slideTo(index) {
                return this.swiper.slideTo(index, 1000, false)
            },
            isCurrent(index) {
                return this.currentReferenceHouseIndex === index
            },
        },

        computed: {
            ...mapGetters([
              "apartmentSizes",
              "currentReferenceHouseIndex",
              "filteredReferenceHouses",
            ]),
            swiper() {
                return this.$refs.refHouseSwiper.swiper
            }
        },

        mounted() {
            const swiper = this.swiper
            const store = this.$store
            swiper.on('slideChange', () => {
                store.commit('setCurrentReferenceHouseIndex', swiper.realIndex)
            });

            // go back to last selected slide, if any
            if (this.currentReferenceHouseIndex > -1) {
                swiper.slideTo(this.currentReferenceHouseIndex, 0, false)
            } else {
                const firstMatchIndex = _.findIndex(this.filteredReferenceHouses, ["matchCriteria", true])

                // show first match by default, if any
                if (firstMatchIndex > -1) {
                    swiper.slideTo(firstMatchIndex, 0, false)
                } else {
                    swiper.slideTo(0, 0, false)
                }
                store.commit('setCurrentReferenceHouseIndex', swiper.realIndex)
            }
        },

        components: {
            ReferenceHouse,
        },
    }
</script>

<style lang="scss">
    // SCSS is found in reference-house-selector.scss and is shared with other (non-Vue) Carousel component
</style>



// WEBPACK FOOTER //
// assets/vue/houseModel/components/houseCarousel.vue